import React from 'react';

import Footer from './Footer';
import { Description, Instructions } from './SidebarWidgets';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';

import { Graph } from 'react-d3-graph';

export default class App extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			graphWidth: 0,
			focused: false,
			focusTarget: null
		}
	}

	componentDidMount() {
		const graphWidth = document.getElementById('graph-container').offsetWidth;
		this.setState({ graphWidth });
	}

	handleLinkClick(source, target) {
		this.setState({
			focused: true,
			focusTarget: {
				edge: true,
				source: source,
				target: target
			}
		});
	}

	handleGraphClick() {
		this.setState({
			focused: false,
			focusTarget: null
		});
	}

	handleNodeClick(nodeId) {
		this.setState({ 
			focused: true,
			focusTarget: {
				node: true,
				id: nodeId
			}
		});
	}

	render() {
		const edges = require('./edges.json');
		const nodes = require('./nodes.json');

		const data = {
			links: edges,
			nodes: nodes
		};

		// config data
		let graphConfig;
		if (this.state.graphWidth) {
			graphConfig = require('./graphConfig.json');
			graphConfig = Object.assign({}, graphConfig, {
				height: window.innerHeight,
				width: this.state.graphWidth
			});
		}
		

		return (
			<Row id="app-main" noGutters={true}>
				<Col md={8} id="graph-container" className="graph-column">
					<Graph
						id="incomprehensible-lang-graph"
						data={ data }
						onClickLink={ (source, target) => this.handleLinkClick(source, target) }
						onClickGraph={ () => this.handleGraphClick() }
						onClickNode={ (nodeId) => this.handleNodeClick(nodeId) }
						config={ graphConfig }
					/>
				</Col>
				<Col md={4} className="sidebar-column">
					<Container className="sidebar-container">
						<h1 className="display-4">Stereotypical <span className="text-warning">Gibberish</span></h1>
						{ this.state.focused && <Description focus={ this.state.focusTarget } /> }
						{ !this.state.focused && <Instructions /> }
						<div id="spacer"></div>
						<Footer />
					</Container>
				</Col>
			</Row>
		);
	}
}